import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { sanitizeReturnUrl } from "@/features/auth/returnUrl"
import {
  SESSION_EXPIRED_FLAG,
  SESSION_EXPIRED_RETURN_URL,
  subscribeSessionExpiredRedirect,
} from "@/features/auth/sessionExpired"

/** После invalid_grant / 401 без refresh — на /login с returnUrl, без ошибки на текущей странице. */
export const SessionExpiredRedirect = () => {
  const [redirectSignal, setRedirectSignal] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => subscribeSessionExpiredRedirect(() => setRedirectSignal((value) => value + 1)), [])

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_EXPIRED_FLAG) !== "1") return
    const storedReturnUrl = sessionStorage.getItem(SESSION_EXPIRED_RETURN_URL)
    const currentPath = `${location.pathname}${location.search}`
    const rawReturnUrl = storedReturnUrl ?? (currentPath.startsWith("/login") ? "/" : currentPath)
    sessionStorage.removeItem(SESSION_EXPIRED_FLAG)
    sessionStorage.removeItem(SESSION_EXPIRED_RETURN_URL)
    const safe = sanitizeReturnUrl(rawReturnUrl, import.meta.env.BASE_URL ?? "/")
    const returnUrl = safe ?? "/"
    navigate(`/login?returnUrl=${encodeURIComponent(returnUrl)}&sessionExpired=1`, { replace: true })
  }, [redirectSignal, navigate, location.pathname, location.search])

  return null
}
